import React from "react";
import { PageHeader } from "./PageHeader";

export const ProgramSesje = props => {
  return (
    <React.Fragment>
      <PageHeader title="Program" />
      <div className="content-wrapper">
        <div className="main-content program">
            <div className="row">
                <h2>Sesje naukowe</h2>
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>Sesja</th>
                            <th>Nazwa sesji</th>
                            <th>Organizatorzy sesji</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr className="s1">
                            <td>S1</td>
                            <td>Fizyka medyczna i biofizyka</td>
                            <td>Prof. E. Stępień, Prof. M. Cieplak, Prof. P. Olko, Prof. T. Sarna, Prof. K. Burda, dr hab. J. Chwiej, dr hab. J. Raczkowska</td>
                        </tr>
                        <tr className="s2">
                            <td>S2</td>
                            <td>Nanofizyka i nanotechnologia</td>
                            <td>Prof. M. Szymoński, Prof. M. Przybylski, dr hab. A. Rycerz</td>
                        </tr>
                        <tr className="s3">
                            <td>S3</td>
                            <td>Fizyka jądrowa</td>
                            <td>Prof. A. Maj, Prof. R. Płaneta, Prof. T. Matulewicz, Prof. E. Stephan, Prof. S. Kistryn</td>
                        </tr>
                        <tr className="s4">
                            <td>S4</td>
                            <td>Fizyka cząstek</td>
                            <td>Prof. M. Praszałowicz, Prof. W. Florkowski, Prof. A. Zalewska, dr hab. I. Grabowska-Bołd</td>
                        </tr>
                        <tr className="s5">
                            <td>S5</td>
                            <td>Fizyka materii skondensowanej</td>
                            <td>Prof. A. Ślebarski, Prof. M. Maśka, Prof. T. Domański, Prof. D. Kaczorowski, Prof. A. Wójs</td>
                        </tr>
                        <tr className="s6">
                            <td>S6</td>
                            <td>Fizyka statystyczna</td>
                            <td>Prof. E. Gudowska-Nowak, dr hab. M. Cieśla, dr hab. B. Dybiec</td>
                        </tr>
                        <tr className="s7">
                            <td>S7</td>
                            <td>Fizyka atomowa, molekularna i optyczna, fotonika, informacja kwantowa</td>
                            <td>Prof. J. Zakrzewski, Prof. M. Żukowski, Prof. J. Koperski, Prof. Cz. Radzewicz</td>
                        </tr>
                        <tr className="s8">
                            <td>S8</td>
                            <td>Grawitacja, kosmologia i astrofizyka</td>
                            <td>Prof. E. Malec, Prof. A. Biesiada, Prof. B. Grządkowski</td>
                        </tr>
                        <tr className="s9">
                            <td>S9</td>
                            <td>Fizyka układów złożonych</td>
                            <td>Prof. K. Kułakowski, Prof. M. A. Nowak, dr hab. D. Grech </td>
                        </tr>
                        <tr className="s10">
                            <td>S10</td>
                            <td>Kobiety w fizyce</td>
                            <td>dr A. Wrońska, Prof. E. Gudowska-Nowak</td>
                        </tr>
                        <tr className="s11">
                            <td>S11</td>
                            <td>Fizyka środowiska</td>
                            <td>Prof. K. Różański</td>
                        </tr>
                        <tr className="s12">
                            <td>S12</td>
                            <td>Sesja "Fizyka - Przemysł - Innowacje"</td>
                            <td>CTT AGH oraz CITTRU UJ</td>
                        </tr>
                        <tr className="s13">
                            <td>S13</td>
                            <td>Zagadnienia interdyscyplinarne fizyki</td>
                            <td>dr D. Goc-Jagło, Prof. J. Spałek, dr. inż. M. Zieliński</td>
                        </tr>
                        <tr className="s14">
                            <td>S14</td>
                            <td>Fizyka ogólna</td>
                            <td>dr D. Goc-Jagło, Prof. J. Spałek, dr. inż. M. Zieliński</td>
                        </tr>
                        <tr className="s15">
                            <td>S15</td>
                            <td>Dydaktyka i popularyzacja fizyki</td>
                            <td>dr W. Zawadzki, dr D. Sokołowska</td>
                        </tr>
                        <tr>
                            <td>DGF</td>
                            <td>Debata - Granice Fizyki</td>
                            <td>Prof. J. Spałek, Prof. L. Sirko</td>
                        </tr>
                        <tr className="sp">
                            <td>SP</td>
                            <td>Sesja plakatowa</td>
                            <td>dr D. Goc-Jagło, Prof. J. Spałek, dr hab. Roman Skibiński, dr. inż. M. Zieliński</td>
                        </tr>
                        <tr className="dyde">
                            <td>DYD</td>
                            <td>Konferencja Dydaktyczna</td>
                            <td>dr W. Zawadzki, dr D. Sokołowska, dr Ł. Stępień, mgr I. Smoter</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>



        </div>
      </div>
    </React.Fragment>
  );
};

ProgramSesje.propTypes = {};
